import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../data-services/auth.service';
import { Store } from '@ngrx/store';
import { selectUrl } from '../../../data-services/stores/selectors/router.selectors';
import { AsyncPipe } from '@angular/common';
import { EventBasic } from '../../../data-services/models/events/event-basic.model';
import { RouterModule } from '@angular/router';
import { adminActions } from '../../../data-services/stores/actions/admin.actions';


@Component({
  selector: 'app-admin-event-menu',
  imports: [AsyncPipe,RouterModule],
  templateUrl: '../ui/admin-event-menu.component.html',
  styleUrl: '../ui/admin-event-menu.component.css'
})
export class AdminEventMenuComponent implements OnInit {
  private readonly _authService = inject(AuthService);
  private readonly _store = inject(Store);
  @Input() lrpEvent?: EventBasic;
  @Output() showWizard = new EventEmitter();
  routerUrl$ = this._store.select(selectUrl);
  loggedIn: boolean = this._authService.checkTokenExpiry();
  adminRole: boolean = this._authService.canAccessAdmin();

  ngOnInit(): void {
    this._store.dispatch(adminActions.getTicketTypes())
  }

  get menuAvailable(): boolean{
    return this.loggedIn && this.adminRole
  }
}
